const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

const styles = require('./DibsRadioButtonInput-style.scss');

const DibsRadioButton = ({
    inputId,
    name,
    value,
    title,
    isSelected,
    onSelect,
    disabled,
    wrapperClass,
    labelClass,
    buttonClass,
    titleClass,
    labelDataTn,
    titleDataTn,
    children
}) => {
    const labelClasses = classnames(styles.labelClass, labelClass);
    const buttonClasses = classnames(styles.radioButton, buttonClass);
    const titleClasses = classnames(styles.titleClass, titleClass);
    return (
        <div className={wrapperClass}>
            <label
                htmlFor={inputId}
                className={labelClasses}
                data-id={value}
                data-tn={labelDataTn}
            >
                <input
                    id={inputId}
                    type="radio"
                    name={name}
                    value={value}
                    defaultChecked={isSelected}
                    disabled={disabled}
                    onChange={onSelect}
                    className={styles.hiddenRadio}
                />
                <span className={buttonClasses}></span>
                <span className={titleClasses} data-tn={titleDataTn}>{title}</span>
            </label>
            {children}
        </div>
    );
};

DibsRadioButton.propTypes = {
    inputId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]).isRequired,
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]).isRequired,
    isSelected: PropTypes.bool.isRequired,
    onSelect: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    labelDataTn: PropTypes.string,
    titleDataTn: PropTypes.string,
    wrapperClass: PropTypes.string,
    buttonClass: PropTypes.string,
    labelClass: PropTypes.string,
    titleClass: PropTypes.string,
    children: PropTypes.node
};

module.exports = DibsRadioButton;



// WEBPACK FOOTER //
// ./assets/js/global/components/DibsRadioButtonInput.jsx